// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"AccountScreen_titleWrapper__3HV4d","paneWrapper":"AccountScreen_paneWrapper__40QAY","actionTilesWrapper":"AccountScreen_actionTilesWrapper__3NWdU"};